module.exports = __webpack_public_path__ + "img/5.955a4bff.png";